import { React, useState, useRef } from "react";
import ContactPopup from "../ContactPopup";
import "../ImportExport/ServicePages.css";

const IncomeTaxReturn = () => {
  

 const [openPopup, setOpenPopup] = useState(false);

    const contactRef = useRef(null);

    const scrollToContact = () => {
        contactRef.current?.scrollIntoView({ behavior: "smooth" });
    }

  return (
    <div className="service-page">

      {/* HERO */}
      <section className="service-hero">
        <h1>Income Tax Return (ITR) Filing Service</h1>
        <p>Fast, accurate, and hassle-free ITR filing for individuals and businesses.</p>
        <button className="hero-btn" onClick={scrollToContact}>
                        Get Started Today
                    </button>
      </section>

      {/* OVERVIEW */}
      <section className="service-section">
        <h2>Overview</h2>
        <p>
          Income Tax Return (ITR) filing is a mandatory process for individuals and businesses 
          to report their income, expenses, and taxes to the Income Tax Department.
        </p>
        <p>
          Timely and accurate filing helps you stay compliant, avoid penalties, 
          and claim eligible tax refunds easily.
        </p>
      </section>

      {/* WHO NEEDS ITR */}
      <section className="service-section">
        <h2>Who Needs to File ITR?</h2>
        <ul>
          <li>Salaried Individuals</li>
          <li>Freelancers & Consultants</li>
          <li>Business Owners</li>
          <li>Companies & Firms</li>
          <li>NRIs with taxable income in India</li>
        </ul>
        <p>
          Even if your income is below the taxable limit, filing ITR helps in loans, visas, and financial records.
        </p>
      </section>

      {/* TYPES */}
      <section className="service-section">
        <h2>Types of ITR We Handle</h2>
        <div className="card">ITR-1 – Salaried Individuals</div>
        <div className="card">ITR-2 – Capital Gains / Multiple Income</div>
        <div className="card">ITR-3 – Business / Professional Income</div>
        <div className="card">ITR-4 – Presumptive Income</div>
        <div className="card">ITR-5/6/7 – Firms, Companies & Trusts</div>
      </section>

      {/* SERVICES */}
      <section className="service-section">
        <h2>Our ITR Filing Services Include</h2>
        <ul>
          <li>Income calculation & tax computation</li>
          <li>Selection of correct ITR form</li>
          <li>Deduction & exemption optimization</li>
          <li>Filing with Income Tax Department</li>
          <li>E-Verification support</li>
          <li>Notice handling & follow-ups</li>
        </ul>
      </section>

      {/* BENEFITS */}
      <section className="service-section">
        <h2>Benefits of Filing ITR</h2>
        <ul>
          <li>✔ Avoid penalties and legal issues</li>
          <li>✔ Claim tax refunds easily</li>
          <li>✔ Proof of income for loans & visas</li>
          <li>✔ Carry forward losses</li>
          <li>✔ Maintain financial credibility</li>
        </ul>
      </section>

      {/* DOCUMENTS */}
      <section className="service-section">
        <h2>Documents Required</h2>
        <ul>
          <li>PAN Card</li>
          <li>Aadhaar Card</li>
          <li>Form 16 / Salary Slips</li>
          <li>Bank Statements</li>
          <li>Investment Proofs (80C, 80D, etc.)</li>
          <li>Business Income Details (if applicable)</li>
        </ul>
      </section>

      {/* DUE DATES */}
      <section className="service-section">
        <h2>Due Dates</h2>
        <ul>
          <li>Individuals: 31st July</li>
          <li>Businesses (Audit Cases): 31st October</li>
        </ul>
        <p>Late filing may attract penalties and interest.</p>
      </section>

      {/* WHY CHOOSE US */}
      <section className="service-section">
        <h2>Why Choose Us?</h2>
        <ul>
          <li>✔ Expert tax professionals</li>
          <li>✔ Maximum tax-saving guidance</li>
          <li>✔ Quick & secure filing</li>
          <li>✔ Affordable pricing</li>
          <li>✔ Dedicated support</li>
        </ul>
      </section>

      {/* CTA */}
      {/* <section className="service-cta">
        <h2>File Your ITR Without Stress</h2>
        <p>Let our experts handle your tax filing smoothly and accurately.</p>
        <button>Get Started Today</button>
      </section> */}
          <div className="cta" ref={contactRef}>
              <h2>File Your ITR Without Stress</h2>
              <p>Let our experts handle your tax filing smoothly and accurately.</p>
      
              <div className="cta-buttons">
                <button onClick={() => setOpenPopup(true)}>Get Started Today</button>
                <ContactPopup
                  isOpen={openPopup}
                  onClose={() => setOpenPopup(false)}
                />
      
                <button className="outline" onClick={() => window.location.href = "tel:9218103915"} >Free Consultation</button>
              </div>
            </div>

    </div>
  );
};

export default IncomeTaxReturn;